import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../packages/kiti/components/presentation/Text'
import FieldValuesFormSection from '../../../../containers/fieldValues/form/FieldValuesFormSection'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'

const FieldsSection = () => {
  const { t } = useTranslation('editPlace')
  const form = useForm()
  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('additionalFields')}
      </Title>
      <Line />
      <Separator weight={4} />

      <FieldValuesFormSection origin={form.type || []} hideTitle />
    </>
  )
}

export default FieldsSection
